import React from 'react';
import { heroData } from '../data/mock';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center bg-white pt-16 md:pt-0 overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 noise-bg" />
      
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-12 md:py-20 lg:py-0 w-full">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-6 items-center min-h-[calc(100vh-5rem)]">
          
          {/* Content — 7 cols on desktop */}
          <div className="lg:col-span-7 space-y-6 md:space-y-8">
            {/* Eyebrow */}
            <div className="flex items-center gap-3 opacity-0 animate-fade-in-up">
              <div className="w-8 h-[1.5px] bg-[#10b981]" />
              <span className="text-[11px] tracking-[0.2em] text-[#10b981] uppercase font-semibold">
                Est. 1996
              </span>
            </div>

            {/* Headline */}
            <h1 className="font-serif text-[2rem] sm:text-[2.5rem] md:text-[3.25rem] lg:text-[3.75rem] xl:text-[4.25rem] text-[#1a2e4a] leading-[1.08] tracking-[-0.01em] opacity-0 animate-fade-in-up animation-delay-100">
              {heroData.headline}
            </h1>

            {/* Subheadline */}
            <p className="text-base sm:text-lg md:text-xl text-slate-500 leading-relaxed max-w-lg opacity-0 animate-fade-in-up animation-delay-200">
              {heroData.subHeadline}
            </p>

            {/* Trust strip */}
            <div className="pt-6 md:pt-8 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8 opacity-0 animate-fade-in-up animation-delay-300">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-[#10b981]" />
                <span className="text-[11px] tracking-[0.15em] text-slate-400 uppercase font-medium">
                  Authorized FSP: 2562
                </span>
              </div>
              <div className="hidden sm:block w-px h-4 bg-slate-200" />
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-[#10b981]" />
                <span className="text-[11px] tracking-[0.15em] text-slate-400 uppercase font-medium">
                  Pretoria, South Africa
                </span>
              </div>
            </div>
          </div>

          {/* Image — 5 cols on desktop */}
          <div className="lg:col-span-5 relative opacity-0 animate-scale-in animation-delay-300">
            <div className="relative aspect-[4/3] lg:aspect-[3/4] overflow-hidden">
              <img
                src="/images/hero.jpg"
                alt="Modern glass architecture"
                className="object-cover w-full h-full img-zoom"
              />
              {/* Gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#1a2e4a]/15 via-transparent to-transparent" />
            </div>
            {/* Corner accent */}
            <div className="absolute -bottom-3 -left-3 w-16 md:w-20 h-16 md:h-20 border-l-2 border-b-2 border-[#10b981] hidden sm:block" />
            <div className="absolute -top-3 -right-3 w-16 md:w-20 h-16 md:h-20 border-t-2 border-r-2 border-[#1a2e4a]/15 hidden sm:block" />
          </div>
        </div>
      </div>
      
      {/* Bottom edge line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" />
    </section>
  );
};

export default Hero;
